import React, { useState, useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const AnalysisFields = (props) => {
    const { data, handleQuestionChange, handleStringMapChange, deleteStringMap, addStringMap, existingQuestions, autoMap } = props;
    const [surveyOptions, setSurveyOptions] = useState([]);
    const [retoolOptions, setRetoolOptions] = useState([]);

    useEffect(() => {
        getSurveyOptions();
        getRetoolOptions();
    }, []) // eslint-disable-line

    function getSurveyOptions() {
        const options = [];
        if (data.type === 'multiple_choice' && data.properties.choices) {
            data.properties.choices.forEach(choice => {
                options.push(choice.label);
            });
        }else if(data.type === 'yes_no'){
            options.push('True');
            options.push('False');
        }
        setSurveyOptions(options);
    }

    function getRetoolOptions() {
        const options = [];
        if (data.type === 'multiple_choice' && data.properties.choices && data.language === 'en') {
            data.properties.choices.forEach(choice => {
                options.push(choice.label);
            });
        } else if (data.type === 'multiple_choice') {
            const engVersion = existingQuestions.find(q => (q.ref === data.ref && q.language === 'en'));
            if (engVersion && engVersion.properties.choices) {
                engVersion.properties.choices.forEach(choice => {
                    options.push(choice.label);
                });
            }
        } else if (data.type === 'yes_no') {
            options.push('Yes');
            options.push('No');
        }
        setRetoolOptions(options);
    }

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <FormControl>
                <InputLabel shrink id="display-label">
                    Display
                </InputLabel>
                <Select
                    labelId="display-label"
                    id="display-select"
                    value={data.display}
                    onChange={(e) => handleQuestionChange(e.target.value, 'display')}
                    displayEmpty
                >
                    <MenuItem value={true}>True</MenuItem>
                    <MenuItem value={false}>False</MenuItem>
                </Select>
            </FormControl>
            {retoolOptions.length > 0 &&
                <Button onClick={()=>autoMap(surveyOptions, retoolOptions)} variant="outlined" color="primary"> Auto Map </Button>
            }
            </div>
            {data['StringMap'] &&
                <div style={{ display: 'flex', 'flexDirection': 'column', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                    <div style={{ width: '99%' }}>
                        <h4> StringMap </h4>
                        {data['StringMap'].map((label, idx) => (
                            <div style={{ display: 'flex', width: '100%', margin: 5 }} key={idx}>
                                <Autocomplete
                                    value={label.survey}
                                    onChange={(e, newValue) => handleStringMapChange(newValue, idx, 'survey')}
                                    freeSolo
                                    options={surveyOptions}
                                    style={{ width: '45%' }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            multiline
                                            onChange={(e) => handleStringMapChange(e.target.value, idx, 'survey')}
                                            variant="outlined"
                                            label="Survey"
                                        />
                                    )}
                                />
                                <ArrowRightAltIcon style={{ marginTop: 15 }} />
                                <Autocomplete
                                    value={label.retool}
                                    onChange={(e, newValue) => handleStringMapChange(newValue, idx, 'retool')}
                                    freeSolo
                                    options={retoolOptions}
                                    style={{ width: '45%' }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            multiline
                                            onChange={(e) => handleStringMapChange(e.target.value, idx, 'retool')}
                                            variant="outlined"
                                            label="Retool"
                                        />
                                    )}
                                />
                                <IconButton aria-label="delete" onClick={() => deleteStringMap(idx)}>
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        ))}
                    </div>
                    <Button onClick={addStringMap} style={{ width: 40 }}> + </Button>
                </div>
            }
        </div>
    )
};

export default AnalysisFields;